"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addPayChannel = addPayChannel;
exports.getPayChannelInfo = getPayChannelInfo;
exports.getPayChannelOption = getPayChannelOption;
exports.listByApp = listByApp;
exports.updatePayChannel = updatePayChannel;
var _request = _interopRequireDefault(require("@/utils/request"));
var _requestMapi = _interopRequireDefault(require("@/utils/requestMapi"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 获取支付通道枚举下拉框
 */
function getPayChannelOption() {
  // return request({
  //   url: '/admin/payChannel/getPayChannelOption',
  //   method: 'get'
  // })
  return (0, _requestMapi.default)({
    url: '/mapi/payment/admin/payChannel/getPayChannelOption',
    method: 'get'
  });
}

/**
 * 新增支付通道配置
 * @param data
 */
function addPayChannel(data) {
  return (0, _request.default)({
    url: '/admin/payChannel/add',
    method: 'post',
    data: data
  });
}

/**
 * 编辑支付通道配置
 * @param data
 */
function updatePayChannel(data) {
  return (0, _request.default)({
    url: '/admin/payChannel/update',
    method: 'post',
    data: data
  });
}

/**
 * 支付通道配置详情
 * @param id
 */
function getPayChannelInfo(id) {
  return (0, _request.default)({
    url: '/admin/payChannel/info',
    method: 'get',
    params: {
      id: id
    }
  });
}

/**
 * 根据小程序ID获取支付通道配置列表
 * @param companyAppId
 */
function listByApp(companyAppId) {
  return (0, _request.default)({
    url: '/admin/payChannel/listByApp',
    method: 'get',
    params: {
      companyAppId: companyAppId
    }
  });
}